module.exports = __webpack_public_path__ + "img/guanyu_xiadan@2x.014005e5.png";